module.exports = __webpack_public_path__ + "static/storage-base-7-7e8dc45cc63ddb1899cd57503cbf1e81.png";